<template>
  <div class="tabs">
    <ul id="myTab" class="nav nav-tabs" role="tablist">
      <li class="nav-item" role="presentation">
        <button
          id="features-tab"
          :aria-selected="
            !this.current || (this.current && this.current === 'features')
          "
          :class="{
            active:
              !this.current || (this.current && this.current === 'features'),
          }"
          aria-controls="features"
          class="nav-link"
          data-bs-target="#features"
          data-bs-toggle="tab"
          role="tab"
          type="button"
          @click="changeTab('features')"
        >
          {{ getTranslation(363) }}
        </button>
      </li>

      <li class="nav-item" role="presentation">
        <button
          id="equipment-tab"
          :aria-selected="this.current && this.current === 'equipment'"
          :class="{
            active: this.current && this.current === 'equipment',
          }"
          aria-controls="equipment"
          class="nav-link"
          data-bs-target="#equipment"
          data-bs-toggle="tab"
          role="tab"
          type="button"
          @click="changeTab('equipment')"
        >
          {{ getTranslation(81) }}
        </button>
      </li>

      <li class="nav-item" role="presentation">
        <button
          id="equipment-tariff-tab"
          :aria-selected="this.current && this.current === 'equipment-tariff'"
          :class="{
            active: this.current && this.current === 'equipment-tariff',
          }"
          aria-controls="equipment-tariff"
          class="nav-link"
          data-bs-target="#equipment-tariff"
          data-bs-toggle="tab"
          role="tab"
          type="button"
          @click="changeTab('equipment-tariff')"
        >
          {{ getTranslation(365) }}
        </button>
      </li>
    </ul>

    <div id="myTabContent" ref="tabContent" class="tab-content">
      <div
        v-show="isScrollbar"
        :key="isScrollbar"
        ref="scrollbar"
        class="scrollbar"
      ></div>
      <div
        v-if="vehicle && vehicle.motors && vehicle.motors[0]"
        id="features"
        :class="{
          'show active': !this.current || this.current === 'features',
        }"
        aria-labelledby="features-tab"
        class="tab-pane fade"
        role="tabpanel"
      >
        <VehicleCharacteristicTabComponent />
      </div>

      <div
        id="equipment"
        :class="{
          'show active': this.current && this.current === 'equipment',
        }"
        aria-labelledby="equipment-tab"
        class="tab-pane fade"
        role="tabpanel"
      >
        <VehicleOptionsTabComponent type="standard" />
      </div>

      <div
        id="equipment-tariff"
        :class="{
          'show active': this.current && this.current === 'equipment-tariff',
        }"
        aria-labelledby="equipment-tariff-tab"
        class="tab-pane fade"
        role="tabpanel"
      >
        <VehicleOptionPriceTabComponent />
      </div>
    </div>
  </div>
</template>

<script>
import VehicleCharacteristicTabComponent from "@/components/VehicleTabs/VehicleCharacteristicTabComponent.vue";
import { mapState } from "pinia";
import VehicleOptionPriceTabComponent from "@/components/VehicleTabs/VehicleOptionsPriceTabComponent.vue";
import { useMainStore } from "@/store";
import { getTranslation } from "@/services/translation-manager";
import VehicleOptionsTabComponent from "@/components/VehicleTabs/VehicleOptionsTabComponent.vue";

export default {
  name: "VehicleTabsComponent",
  data() {
    return {
      current: "",
      isScrollbar: false,
    };
  },
  computed: {
    ...mapState(useMainStore, {
      vehicle: (store) => store.vehicle,
    }),
  },
  mounted() {
    this.current = this.$route.hash.slice(1);
    setTimeout(this.initScrollbar, 20);
  },
  beforeUnmount() {
    this.cancelScrollbar();
  },
  components: {
    VehicleOptionsTabComponent,
    VehicleOptionPriceTabComponent,
    VehicleCharacteristicTabComponent,
  },
  methods: {
    getTranslation,
    changeTab(id) {
      this.current = id;
      this.$router.push({ name: "Vehicle", hash: "#" + this.current });
      setTimeout(this.initScrollbar, 20);
    },

    initScrollbar() {
      this.$refs.scrollbar.style.top = top + "px";
      this.$refs.tabContent.removeEventListener("scroll", this.onScroll);
      const tabContent = this.$refs.tabContent;
      const innerContent = tabContent.querySelector(".show");
      this.isScrollbar = innerContent.offsetHeight > tabContent.offsetHeight;
      if (this.isScrollbar) {
        this.$refs.tabContent.addEventListener("scroll", this.onScroll);
      }
    },

    cancelScrollbar() {
      this.$refs.tabContent.removeEventListener("scroll", this.onScroll);
    },

    onScroll(e) {
      const scrollbar = this.$refs.scrollbar;
      const tabContent = this.$refs.tabContent;
      const innerContent = tabContent.querySelector(".show");

      let position =
        e.target.scrollTop /
        (innerContent.offsetHeight - tabContent.offsetHeight + 20);

      if (position > 1) {
        position = 1;
      } else if (position < 0) {
        position = 0;
      }

      const top = (innerContent.offsetHeight - 150) * position + 20;

      scrollbar.style.transform = "translateY(" + top + "px)";
    },
  },
};
</script>

<style lang="scss" scoped>
.tabs {
  margin-top: 105px;
  height: 100%;
  max-height: calc(100% - 320px);

  .nav-tabs {
    border: none;
    margin-bottom: 15px;
  }

  .nav-link {
    background: none;
    border: none;
    padding: 0;
    font-size: 20px;
    color: $blue;

    &.active {
      background: transparent;
      color: $red;
      border-bottom: 4px solid $red;
    }
  }

  .nav-item + .nav-item {
    margin-left: 30px;
  }

  .tab-content {
    padding: 20px 80px 0 0;
    height: 100%;
    overflow: scroll;
    position: relative;

    -ms-overflow-style: none; /* Internet Explorer 10+ */
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none; /* Safari and Chrome */
    }

    .scrollbar {
      content: "";
      position: absolute;
      right: 2px;
      top: 0;
      background: $blue;
      width: 12px;
      height: 150px;
      border-radius: 8px;
    }
  }
}
</style>
